import { ErrorResponse } from '../types/form';
import { ApiResources, createErrorResponse, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

export interface IPostSelectedOfferResponse {
  dealId: string;
  rate: number;
  monthlyPaymentAmount: number;
  term: number;
  offerType: string;
  success: boolean;
  message: string;
}

export const postSelectedOffer = async (dealId: string): Promise<IPostSelectedOfferResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.lenderDealAcitve)}/${dealId}/active`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
  };
  try {
    const jsonResponse = await fetch(endpoint, request);
    return processResponse(jsonResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
